import { skipToken } from '@reduxjs/toolkit/query/react'
import { useGetEntitySummaryQuery } from './syncReportsApi'
import { DIRECTION } from './recordStatus'
const EMPTY = []
const summaryArgs = (connection, direction, range) => {
    if (!connection || !connection.instances || !connection.instances[0]) {
        return skipToken
    }
    const endpoint = direction === DIRECTION.target ? connection.target : connection.source
    return {
        instanceId: connection.instances[0].id,
        endpointId: endpoint.id,
        requestType: direction.requestType,
        range: range || undefined
    }
}
const useEntitySummaries = (connection, range) => {
    const sourceArgs = summaryArgs(connection, DIRECTION.source, range)
    const targetArgs = summaryArgs(connection, DIRECTION.target, range)
    const source = useGetEntitySummaryQuery(sourceArgs)
    const target = useGetEntitySummaryQuery(targetArgs)

    return {
        source: source.data || EMPTY,
        target: target.data || EMPTY,
        isLoading: source.isLoading || target.isLoading,
        isFetching: source.isFetching || target.isFetching,
        isError: source.isError || target.isError,
        refetch: () => {
            if (sourceArgs !== skipToken) source.refetch()
            if (targetArgs !== skipToken) target.refetch()
        }
    }
}

export default useEntitySummaries
